import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import Dropdown from "react-dropdown";
import { withTheme } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-dropdown/style.css";
const moment = require("moment");

export default withTheme(({ options, onChange, value, placeholder }) => {
  return (
    <Dropdown
      options={options}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
    />
  );
});
